import { Component, Input } from '@angular/core';
import { LoadingEventHandler } from '../../services/event-handlers/loading-event-handler.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
    @Input() isVisible: boolean = false;

    constructor(private loadingEventHandler: LoadingEventHandler) { 
        this.loadingEventHandler.onLoadingRequested().subscribe((isBusy: boolean) => {
            this.isVisible = isBusy;
        });
    }
}
